import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNMessage } from './snmessage';

@RegisterItem()
export class SNSMSMessage extends SNMessage {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNMessage.SNSMSMessage';
    }

    public clone(): any {
        return new SNSMSMessage();
    }
}

